// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1577":"b8906ecb","1676":"029fec2c","2086":"e7ee4404","4036":"31d6cfe0","6585":"bac8d159"}[chunkId] + ".chunk.css";
};